import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const PlayersService = {
  async getAll(clubId, { page = 1, limit = 20, ...params } = {}) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient
        .get(`/clubs/${clubId}/players`, { params: { page, limit, ...params } })
        .then((response) => response.data),
    );
  },
  async create(payload) {
    return safeRequest(
      apiClient.post("/players", payload).then((response) => response.data),
    );
  },
  async patchMe(payload) {
    return safeRequest(
      apiClient.patch("/players/me", payload).then((response) => response.data),
    );
  },
  async patch(playerId, payload) {
    return safeRequest(
      apiClient.patch(`/players/${playerId}`, payload).then((response) => response.data),
    );
  },
  async uploadAvatar(playerId, file) {
    const formData = new FormData();
    formData.append("avatar", file);

    return safeRequest(
      apiClient
        .post(`/players/${playerId}/avatar`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => response.data),
    );
  },
  async getById(playerId) {
    return safeRequest(
      apiClient
        .get(`/players/${playerId}`)
        .then((response) => response.data),
    );
  },
  async getPosition(playerId) {
    return safeRequest(
      apiClient
        .get(`/players/${playerId}/position`)
        .then((response) => response.data),
    );
  },
  async getDashboard(playerId, { clubId } = {}) {
    return safeRequest(
      apiClient
        .get(`/players/${playerId}/dashboard`, {
          params: clubId ? { clubId } : undefined,
        })
        .then((response) => response.data),
    );
  },
  async getRankings(playerId) {
    return safeRequest(
      apiClient
        .get(`/players/${playerId}/rankings`)
        .then((response) => response.data),
    );
  },
  async resetPassword(playerId) {
    return safeRequest(
      apiClient
        .post(`/players/${playerId}/reset-password`)
        .then((response) => response.data),
    );
  },
};
